import React, { useRef } from "react";
import { BiSolidImageAdd } from "react-icons/bi";
import styled from "styled-components";
import { COLORS } from "../../COLORS";
type TypeProps = {
  setImgPreviewUrl: React.Dispatch<React.SetStateAction<string>>;
  setImgToUpload: React.Dispatch<React.SetStateAction<File[] | null>>;
  setInfo: React.Dispatch<React.SetStateAction<string>>;
};
const UploadOneImgCarre = ({
  setImgPreviewUrl,
  setImgToUpload,
  setInfo,
}: TypeProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const file: FileList | null = event.target.files[0];
    if (event.target.files) {
      const file: File | null = event.target.files[0];
      // const maxSize = 1826;
      const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
      if (file) {
        setInfo("");
        if (file.size < maxSize) {
          const img: string | null | undefined | HTMLImageElement = new Image();
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent<FileReader>) => {
            if (e.target?.result && typeof e.target.result === "string") {
              img.src = e.target.result; // On assigne le contenu (sous forme d'URL Data) à la source de l'image
            }
          };

          img.onload = () => {
            if (img.width === img.height) {
              const fileUrl = URL.createObjectURL(file);
              setImgToUpload([file]);
              setImgPreviewUrl(fileUrl);
            } else {
              setInfo("Image n'est pas carrée (ratio attendu 1:1) 🤧");
            }
          };
          //lire img
          reader.readAsDataURL(file);
        } else {
          setInfo("Image trop grande ! Max 2 Mo");
        }
      } else {
        setInfo("Aucune image sélectionnée 😰");
      }
    }
  };
  const handleIconClick = () => {
    if (inputRef.current) {
      inputRef.current.click(); // Déclenche le clic sur l'input caché
    }
  };
  return (
    <StyledUploadOneImgCarre>
      <p>ratio 1:1 (carré) & max 1Mo</p>
      <input
        type="file"
        ref={inputRef}
        accept=".jpg, .jpeg"
        onChange={handleFileChange}
      />
      <BiSolidImageAdd className="icon-file" onClick={handleIconClick} />
      <p>Charger image .jpg ou jpeg</p>
    </StyledUploadOneImgCarre>
  );
};

export default UploadOneImgCarre;
const StyledUploadOneImgCarre = styled.div`
  background: ${COLORS.main};
  padding: 10px;
  width: 30%;
  height: 15vh;
  margin: 10px auto;
  border-radius: 20px;
  border: solid 2px ${COLORS.border_and_text_blue};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
    width: 100%;
    font-size: 0.8em;
    color: ${COLORS.border_and_text_blue};
  }
  input {
    display: none;
  }
  .icon-file {
    cursor: pointer;
    font-size: 4em;
    color: ${COLORS.border_and_text_blue};
  }
  @media screen and (max-width: 445px) {
    width: 70%;
  }
`;
